module.exports = __webpack_public_path__ + "static/img/ticket-claim-title.38f5d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/ticket-claim-title.png
// module id = /E4r
// module chunks = 1